import React, { useEffect, useRef, useState } from 'react';
import '../style.css';
import { FaFacebookF, FaYoutube, FaInstagram } from 'react-icons/fa';

const videos = [
   { src: '/video/video1.mp4', youtube: 'https://www.youtube.com/watch?v=pe31yvIBSLw' }, 
  { src: '/video/video2.mp4', youtube: 'https://www.youtube.com/watch?v=ClEHAAQckgs' },
   { src: '/video/video3.mp4', youtube: 'https://www.youtube.com/watch?v=j96Om7eJg0I' },
   { src: '/video/video4.mp4', youtube: 'https://www.youtube.com/watch?v=QZ-32nFQIDw' } 
  ]; 

const HeroSection = ({ darkMode, onGetStartedClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRefs = useRef([]);

  // Cycle videos every 12 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % videos.length);
    }, 12000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
  videoRefs.current.forEach((video, index) => {
    if (video) {
      if (index === currentIndex) {
        video.currentTime = 0;
        video
          .play()
          .catch((e) => {
            // Suppress the known "paused to save power" error
            if (
              e.name !== "NotAllowedError" &&
              !e.message.includes("paused to save power")
            ) {
              console.warn("Playback failed:", e);
            }
          });
      } else {
        video.pause();
      }
    }
  });
}, [currentIndex]);

  return (
    /*-*/
    
      <div className="container-fluid scroll-target shadow-sm p-5 my-4 rounded-3 ">
        <div className="row align-items-start">
          
          {/* Text Section */}
         <div className="col-12 col-md-6 text-center order-2 order-md-1 animate_animated animate_fade-in-left">
          <div className="row">
           <div className="col-12 text-center text-dark py-4 px-3">
                
            </div>
            </div>
           <h1 className="mb-4 fw-bold display-5 text-dark">Grey Imports</h1>

      <p className="mb-3 text-dark fs-6">
        At Grey Imports, we believe compliance shouldn’t be complicated.<br/>
        That’s why we’ve built an all-in-one platform designed for importers, engineers, 
        and compliance professionals who want speed, accuracy, and transparency.
      </p>

      <p className="mb-3 text-dark fs-6">
        From Model Reports and AVV approvals to live SEVS expiry tracking and easy order 
        management, our platform streamlines every step of the process.
      </p>

      <p className="mb-3 text-dark fs-6">
        Our mission is to make compliance more accessible, transparent, and affordable. 
        Grey Imports empowers customers to focus on what matters most—getting vehicles 
        on the road, faster and smarter.
      </p>
     <button className="btn btn-success btn-lg mt-3" onClick={onGetStartedClick}>Contact Now</button> 
           </div>

          

          {/* Video Crossfade Section */}
          <div className=" col-12 col-md-6 text-center order-1 order-md-2 animate-fade-in-right">
            <div className="ratio ratio-16x9  position-relative rounded-3  shadow-lg  overflow-hidden  ">
               <a
    href={videos[currentIndex].youtube}
    target="_blank"
    rel="noopener noreferrer"
    className="video-click-overlay"
  >
              {videos.map((video, index) => (
                <video
                  key={index}
                  ref={(el) => (videoRefs.current[index] = el)}
                  src={video.src}
                  muted
                  playsInline
                  preload="auto"
                  className={`crossfade-video ${index === currentIndex ? 'active' : ''}`}
                  style={{
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: index === currentIndex ? 'block' : 'none',
  }}
                />
              ))}
              </a>
            </div>

            {/* Dots */}
            <div className="video-dots d-flex justify-content-center mt-3">
              {videos.map((_, index) => (
                <span
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`dot mx-1 ${currentIndex === index ? 'active' : ''}`}
                  style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    display: 'inline-block',
                    backgroundColor: currentIndex === index ? '#198754' : '#ccc',
                    cursor: 'pointer',
                    
                  }}
                  
                />
              ))}
            </div>

            {/* Social Icons */}
           
          </div>
        </div>
      </div>
    
  );
};

export default HeroSection;
